module.exports = __webpack_public_path__ + "media/images/bundle-complete@2x-78d1084e68005800a3641b68c25c2cf3.png";